import { render, staticRenderFns } from "./ConceptDetails.vue?vue&type=template&id=af2e0098&"
import script from "./ConceptDetails.vue?vue&type=script&lang=ts&"
export * from "./ConceptDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports